var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-table',{attrs:{"url":"/api/v1/blacklistModerator","attributes":[
      {
        attribute: 'word',
        name: 'Wort',
        type: 'InputCell',
        url: 'update_url'
      },
      {
        attribute: 'created_by.name',
        name: 'Erstellt von'
      },
      {
        attribute: 'created_at',
        name: 'Erstellt um',
        type: 'DateTimeCell'
      },
      {
        attribute: 'updated_by.name',
        name: 'Updated von'
      },
      {
        attribute: 'updated_at',
        name: 'Updated um',
        type: 'DateTimeCell'
      },
      {
        notification: 'Das Wort wurde aus dem Wörterbuch gelöscht',
        name: 'Entfernen',
        type: 'DeleteCell',
        label: 'Löschen',
        sortable: false
      }
    ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Wörter bearbeiten")])])]),_vm._v(" "),_c('resource',{attrs:{"resource":"blacklistModerator","resourceName":"Blacklist","attributes":_vm.attributes},on:{"resource-persisted":function($event){return _vm.$bus.$emit('refresh-table')}}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h4',[_vm._v("Wörter hinzufügen")])])]),_vm._v(" "),_c('v-table',{attrs:{"name":"BlacklistMessages","url":"/api/v1/blacklistMessage","attributes":[
      {
        attribute: 'id',
        name: 'ID'
      },
      {
        name: 'Moderator',
        attribute: 'moderator_id',
        type: 'UserCell',
        sortable: false
      },
      {
        name: 'User',
        attribute: 'customer_id.name',
        sortable: false
      },
      {
        name: 'Fake',
        attribute: 'fake_profile_id.name',
        sortable: false
      },
      {
        name: 'Nachricht',
        attribute: 'message',
        type: 'SupportShortendMessageCell'
      },
      {
        name: 'Eingegangen',
        attribute: 'created_at',
        type: 'DateTimeCell'
      },
      {
        name: 'Moderator gesperrt',
        attribute: 'blocked',
        type: 'ToggleCell',
        url: 'block_toggle_url'
      },
      {
        name: 'Status',
        attribute: 'read',
        type: 'ToggleCell',
        url: 'read_toggle_url'
      },
      {
        name: 'Bearbeitung',
        type: 'SupportReadByCell'
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }